import React, { useEffect, useState, createElement } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { WistiaVideo } from '../components/WistiaVideo';
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel Code
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode?.insertBefore(t, s);
    f.fbq('init', '1288215226741477');
    f.fbq('track', 'PageView');
    // noscript fallback
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=1288215226741477&ev=PageView&noscript=1';
    document.body.appendChild(noscriptImg);
    return () => {
      document.body.removeChild(noscriptImg);
    };
  }, []);
  const scrollToRegistro = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    e.preventDefault();
    const element = document.getElementById('registro');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#5D2B85] text-gray-100 font-sans selection:bg-blue-500/30" data-id="element-2">
      {/* BARRA STICKY SUPERIOR */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#FFD700] shadow-lg" data-id="element-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4">
          <div className="flex items-center justify-center h-14 text-sm sm:text-base text-center" data-id="element-5">
            <span className="text-black font-bold" data-id="element-6">
              ⚠️ El registro cierra el 13 de abril a las 11:59pm · Cupos
              limitados para la sesión en vivo
            </span>
          </div>
        </div>
      </div>

      {/* SECCIÓN 1 — HERO */}
      <section className="pt-32 pb-16 lg:pt-40 lg:pb-24 bg-[#5D2B85]" data-id="element-7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-9">
            <div className="space-y-8" data-id="element-10">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-[#FFAB03] pt-[0px] pb-[0px] pl-[015px] pr-[015px]" data-id="element-11">
                Descubre por qué sigues volviendo al mismo límite — aunque ya lo
                hayas intentado todo.
              </h1>
              <div className="w-full rounded-2xl overflow-hidden" data-id="element-12">
                <WistiaVideo mediaId="uoyvyozfhg" aspectRatio={16 / 9} className="w-full" data-id="element-13" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-14">
                En esta masterclass virtual en vivo, Jaime Nieto te ayudará a
                identificar tu código del límite: el patrón mental y emocional
                que te frena sin que lo veas. 14 de abril · 8pm Colombia · En
                vivo por Zoom · $2 USD
              </p>
              <div className="inline-block bg-[#FFA903] rounded-lg px-6 py-4 border border-gray-700" data-id="element-15">
                <p className="font-medium text-[#000000]" data-id="element-16">
                  Más de 12,000 personas transformadas · 9 países · 10 años de
                  resultados reales
                </p>
              </div>
              <p className="text-lg text-white font-bold text-center leading-relaxed py-4 pl-5 bg-[#3D1F6E] rounded-lg border-l-[3px] border-[#FFD700]" data-id="element-17">
                En 90 minutos vas a salir
                <br data-id="element-18" />
                con tu patrón escrito
                <br data-id="element-19" />
                en una frase —<br data-id="element-20" />
                en tu propio cuaderno.
                <br data-id="element-21" />
                <span className="italic" data-id="element-22">Por primera vez visible para ti.</span>
              </p>
            </div>

            <div className="rounded-2xl p-6 sm:p-8 shadow-2xl border border-gray-700 bg-[#FFFFFF]" data-id="element-23">
              <h3 className="text-2xl font-bold text-[#000000] mb-6 text-center" data-id="element-24">
                Reserva tu lugar por $2
              </h3>
              <a href="https://pay.hotmart.com/S105294167I?off=y3iwer8i" target="_blank" rel="noopener noreferrer" onClick={() => {
              const f = window as any;
              if (f.fbq) f.fbq('track', 'InitiateCheckout');
            }} className="block w-full text-center bg-[#FFD800] hover:bg-[#E6C200] text-black font-bold text-xl sm:text-2xl px-8 py-6 rounded-2xl shadow-[0_4px_14px_rgba(0,0,0,0.25)] border border-[#FFD800]/20 transition-all transform hover:scale-105" data-id="element-25">
                Reserva tu lugar por $2
              </a>
              <p className="text-center text-[#000000] mt-6 text-sm flex items-center justify-center gap-2" data-id="element-26">
                🔒 Pago seguro · En vivo por Zoom · $2 USD · Garantía de
                devolución durante los primeros 20 minutos
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 2 — PAIN POINTS */}
      <section className="py-16 lg:py-24 bg-[#5D2B85] border-t border-gray-800" data-id="element-27">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-12 text-center" data-id="element-29">
            Esta sesión es para personas que saben que ya no pueden seguir en el
            mismo patrón.
          </h2>
          <ul className="space-y-6 mb-12" data-id="element-30">
            {['Llevas años leyendo y algo sigue igual', 'Sabes lo que quieres pero algo te paraliza', 'Empiezas con todo y siempre te detienes', 'La motivación te dura tres días', 'Sientes que puedes más pero no entiendes por qué'].map((point, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-300" data-id="element-31">
                <ArrowRight className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" data-id="element-32" />
                <span data-id="element-33">{point}</span>
              </li>)}
          </ul>
          <p className="text-xl text-[#000000] leading-relaxed bg-[#FFA903] p-8 rounded-2xl border border-gray-700" data-id="element-34">
            No te falta información. No te falta fuerza de voluntad. Hay un
            patrón mental y emocional que te devuelve al mismo punto cada vez
            que intentas avanzar. En El Código del Límite vas a identificar cuál
            es el tuyo y por qué se repite.
          </p>
        </div>
      </section>

      {/* SECCIÓN 3 — TESTIMONIALS */}
      <section className="py-16 lg:py-24 bg-white text-gray-900" data-id="element-35">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
          <div className="text-center mb-16" data-id="element-37">
            <h2 className="text-3xl lg:text-4xl font-bold mb-4" data-id="element-38">
              Ellos también vivían atrapados en el mismo patrón. Esto empezó a
              cambiar cuando lograron verlo.
            </h2>
            <p className="text-xl text-gray-600" data-id="element-39">
              Grabados en caliente · Sin guión · Solo la verdad de lo que
              vivieron.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-40">
            {/* TARJETA 1 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col" data-id="element-41">
              <WistiaVideo mediaId="wum5peq71x" aspectRatio={1} className="w-full" data-id="element-42" />
              <div className="p-6 flex-1 flex flex-col" data-id="element-43">
                <p className="font-bold text-gray-900 mb-4" data-id="element-44">
                  PATRICIA · Miami · Poder Total
                </p>
                <div className="text-gray-600 flex-1 space-y-2" data-id="element-45">
                  <p data-id="element-46">
                    <span className="font-semibold text-gray-800" data-id="element-47">Antes:</span>{' '}
                    Empezaba todo y no terminaba nada. Dudaba constantemente de
                    sí misma.
                  </p>
                  <p data-id="element-48">
                    <span className="font-semibold text-gray-800" data-id="element-49">
                      Descubrimiento:
                    </span>{' '}
                    Identificó el patrón que la llevaba a buscar validación
                    externa.
                  </p>
                  <p className="italic" data-id="element-50">
                    "Hoy me miro al espejo y digo — ¡guau! Puedo reconocer mi
                    valor y mi poder que siempre estuve buscando en otras
                    personas."
                  </p>
                </div>
              </div>
            </div>

            {/* TARJETA 2 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col" data-id="element-51">
              <WistiaVideo mediaId="tu10u96bf0" aspectRatio={1} className="w-full" data-id="element-52" />
              <div className="p-6 flex-1 flex flex-col" data-id="element-53">
                <p className="font-bold text-gray-900 mb-4" data-id="element-54">
                  DAMIÁN BECHARA · Miami · Poder Total
                </p>
                <div className="text-gray-600 flex-1 space-y-2" data-id="element-55">
                  <p data-id="element-56">
                    <span className="font-semibold text-gray-800" data-id="element-57">Antes:</span>{' '}
                    Se sentía inseguro y sin conexión real con las personas.
                  </p>
                  <p data-id="element-58">
                    <span className="font-semibold text-gray-800" data-id="element-59">
                      Descubrimiento:
                    </span>{' '}
                    Identificó que vivía en una imagen que no era real.
                  </p>
                  <p className="italic" data-id="element-60">
                    "Era un hombre con cero contacto personal con nadie. Lo
                    descubrí aquí. Al final era mentira lo que creía de mí
                    mismo."
                  </p>
                </div>
              </div>
            </div>

            {/* TARJETA 3 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col" data-id="element-61">
              <WistiaVideo mediaId="aiwb3nck8w" aspectRatio={1} className="w-full" data-id="element-62" />
              <div className="p-6 flex-1 flex flex-col" data-id="element-63">
                <p className="font-bold text-gray-900 mb-4" data-id="element-64">
                  LORENA · Miami · Poder Total
                </p>
                <div className="text-gray-600 flex-1 space-y-2" data-id="element-65">
                  <p data-id="element-66">
                    <span className="font-semibold text-gray-800" data-id="element-67">Antes:</span>{' '}
                    No confiaba en sí misma y buscaba respuestas afuera.
                  </p>
                  <p data-id="element-68">
                    <span className="font-semibold text-gray-800" data-id="element-69">
                      Descubrimiento:
                    </span>{' '}
                    Entendió que la sanación estaba dentro de ella.
                  </p>
                  <p className="italic" data-id="element-70">
                    "Hoy soy una mujer libre de tomar cualquier elección en su
                    vida."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 4 — VALUE PROPOSITION */}
      <section className="py-16 lg:py-24 bg-[#5D2B85]" data-id="element-71">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
          <h2 className="text-3xl lg:text-4xl font-bold mb-8 text-[#FFA903]" data-id="element-73">
            Esta no es una masterclass para darte más información. Es una sesión
            para ayudarte a ver el origen del patrón que te frena.
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-74">
            Muchas personas no avanzan porque repiten un patrón interno que
            gobierna sus decisiones, relaciones y resultados sin que lo noten. A
            eso lo llamamos el código del límite.
          </p>
          <ul className="space-y-6 mb-12" data-id="element-75">
            {['Qué patrón te está frenando y cómo se instaló sin que lo notaras', 'Por qué la información, la motivación y el esfuerzo no han sido suficientes', 'Cómo identificar tu patrón específico con claridad', 'Qué necesitas para empezar a romperlo'].map((point, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-300" data-id="element-76">
                <ArrowRight className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" data-id="element-77" />
                <span data-id="element-78">{point}</span>
              </li>)}
          </ul>
          <p className="text-2xl font-bold text-white bg-blue-900/30 p-6 rounded-xl border border-blue-500/30" data-id="element-79">
            90 minutos que van a explicar lo que años de intentarlo solo no han
            podido resolver.
          </p>
        </div>
      </section>

      {/* SECCIÓN 5 — ABOUT JAIME */}
      <section className="py-16 lg:py-24 bg-white text-gray-900" data-id="element-80">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
          <h2 className="text-3xl lg:text-4xl font-bold text-center mb-16" data-id="element-82">
            Conoce a Jaime Nieto
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-83">
            <div className="aspect-square bg-gray-200 rounded-3xl overflow-hidden relative shadow-xl" data-id="element-84">
              {/* Placeholder de foto de Jaime Nieto */}
              <img src="https://cdn.magicpatterns.com/uploads/5CP4tbZwnSp4ern6jPcPBL/Portada_Jaime_Bogota_(1)_(1).jpg" alt="Jaime Nieto" className="absolute inset-0 w-full h-full object-cover mt-[0px] mb-[0px] ml-[015px] mr-[015px]" data-id="element-85" />
            </div>
            <div data-id="element-86">
              <p className="text-xl text-gray-700 leading-relaxed" data-id="element-87">
                Jaime Nieto no siempre tuvo las respuestas. Hubo un momento en
                que también estaba atrapado en el mismo ciclo. La diferencia es
                que encontró el origen — y desarrolló un proceso para
                identificarlo. Hoy lleva más de 10 años guiando procesos de
                transformación personal en 9 países. Más de 12,000 personas han
                identificado el patrón que los frenaba. El 14 de abril es tu
                turno.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 6 — MASTERCLASS STRUCTURE */}
      <section className="py-16 lg:py-24 bg-[#5D2B85]" data-id="element-88">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#FFA903] mb-16 text-center max-w-4xl mx-auto" data-id="element-90">
            En 90 minutos vas a entender qué te frena, por qué se repite y cómo
            empezar a verlo con claridad.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-91">
            <div className="bg-[#FFA903] rounded-2xl p-8 border border-gray-700 shadow-xl" data-id="element-92">
              <h3 className="text-xl font-bold text-[#000000] mb-4" data-id="element-93">
                BLOQUE 1 — EL DIAGNÓSTICO
              </h3>
              <p className="text-[#000000] text-lg" data-id="element-94">
                Qué patrón te está frenando y cómo se instaló sin que lo notaras
              </p>
            </div>
            <div className="bg-[#FFA903] rounded-2xl p-8 border border-gray-700 shadow-xl" data-id="element-95">
              <h3 className="text-xl font-bold text-[#000000] mb-4" data-id="element-96">
                BLOQUE 2 — EL PORQUÉ
              </h3>
              <p className="text-[#000000] text-lg" data-id="element-97">
                Por qué la información, la motivación y el esfuerzo no han sido
                suficientes
              </p>
            </div>
            <div className="bg-[#FFA903] rounded-2xl p-8 border border-gray-700 shadow-xl" data-id="element-98">
              <h3 className="text-xl font-bold text-[#000000] mb-4" data-id="element-99">
                BLOQUE 3 — EL PROCESO
              </h3>
              <p className="text-[#000000] text-lg" data-id="element-100">
                Cómo identificar tu patrón específico y qué primer paso
                necesitas para empezar a romperlo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 7 — IDEAL ATTENDEE */}
      <section className="py-16 lg:py-24 bg-white text-gray-900" data-id="element-101">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
          <h2 className="text-3xl lg:text-4xl font-bold mb-12 text-center" data-id="element-103">
            Esta masterclass es para ti si...
          </h2>
          <p className="text-xl text-gray-700 text-center mb-8 font-medium" data-id="element-104">
            No vienes a escuchar ideas bonitas. Vienes a ver el origen.
          </p>
          <ul className="space-y-6 bg-gray-50 p-8 sm:p-12 rounded-3xl border border-gray-100 shadow-sm" data-id="element-105">
            {['Sientes que hay una versión de ti que no has podido alcanzar todavía', 'Ya intentaste cambiar algo y el mismo patrón sigue apareciendo', 'Quieres entender de verdad qué es lo que te tiene frenado', 'Estás dispuesto a ver algo que quizás no has querido ver antes', 'Tienes 90 minutos el 14 de abril para invertir en lo más importante — tú mismo'].map((point, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-700" data-id="element-106">
                <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-107" />
                <span data-id="element-108">{point}</span>
              </li>)}
          </ul>
        </div>
      </section>

      {/* SECCIÓN 8 — REGISTRATION */}
      <section id="registro" className="py-16 lg:py-24 bg-[#5D2B85] scroll-mt-14" data-id="element-109">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-111">
            <div className="space-y-8" data-id="element-112">
              <h2 className="text-3xl lg:text-5xl font-bold text-[#FFA903]" data-id="element-113">
                Tu acceso incluye:
              </h2>
              <ul className="space-y-4" data-id="element-114">
                {['90 minutos en vivo con Jaime Nieto', 'Workbook de trabajo previo a la masterclass', 'Grabación de la sesión por 48 horas', 'Acceso al chat en vivo durante la masterclass', 'Sesión de preguntas y respuestas al final'].map((point, i) => <li key={i} className="flex items-center gap-3 text-lg text-gray-300" data-id="element-115">
                    <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-116" />
                    <span data-id="element-117">{point}</span>
                  </li>)}
              </ul>
              <div className="bg-[#FFA903] rounded-xl p-6 border border-gray-700 mt-8" data-id="element-118">
                <p className="text-[#000000]" data-id="element-119">
                  🔒 Riesgo cero. Si en los primeros 20 minutos sientes que no
                  era lo que esperabas, te devolvemos tus $2 USD. Sin preguntas.
                </p>
              </div>
            </div>

            <div className="rounded-2xl p-6 sm:p-8 shadow-2xl border border-gray-700 flex flex-col items-center justify-center bg-[#FFFFFF]" data-id="element-120">
              <a href="https://pay.hotmart.com/S105294167I?off=y3iwer8i" target="_blank" rel="noopener noreferrer" onClick={() => {
              const f = window as any;
              if (f.fbq) f.fbq('track', 'InitiateCheckout');
            }} className="block w-full text-center bg-[#FFD800] hover:bg-[#E6C200] text-black font-bold text-xl sm:text-2xl px-8 py-6 rounded-2xl shadow-[0_4px_14px_rgba(0,0,0,0.25)] border border-[#FFD800]/20 transition-all transform hover:scale-105" data-id="element-121">
                Sí, quiero reservar mi lugar por $2
              </a>
              <p className="text-center text-[#000000] mt-6 text-sm flex items-center justify-center gap-2" data-id="element-122">
                🔒 Pago seguro · En vivo por Zoom · $2 USD · Garantía de
                devolución durante los primeros 20 minutos
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 9 — FAQ */}
      <section className="py-16 lg:py-24 bg-[#1a0a2e]" data-id="element-123">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
          <h2 className="text-3xl lg:text-4xl font-bold mb-12 text-center text-white" data-id="element-125">
            Lo que la gente pregunta antes de registrarse
          </h2>
          <div className="divide-y divide-gray-700/50" data-id="element-126">
            <div className="py-8" data-id="element-127">
              <p className="font-bold text-white text-lg mb-3" data-id="element-128">
                ¿Necesito haber hecho algún proceso de desarrollo personal
                antes?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-129">
                No necesitas experiencia previa. Pero sí apertura para ver con
                honestidad el patrón que te ha estado frenando.
              </p>
            </div>
            <div className="py-8" data-id="element-130">
              <p className="font-bold text-white text-lg mb-3" data-id="element-131">
                ¿Es una masterclass grabada o en vivo?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-132">
                Es 100% en vivo por Zoom con Jaime Nieto. Tendrás acceso a la
                grabación por 48 horas después del evento.
              </p>
            </div>
            <div className="py-8" data-id="element-133">
              <p className="font-bold text-white text-lg mb-3" data-id="element-134">
                ¿Qué necesito para conectarme?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-135">
                Solo internet y un dispositivo. La masterclass es por Zoom. El
                link te llega por email y WhatsApp el 14 de abril a las 7pm —
                una hora antes de empezar.
              </p>
            </div>
            <div className="py-8" data-id="element-136">
              <p className="font-bold text-white text-lg mb-3" data-id="element-137">
                ¿Puedo ver la grabación si no puedo conectarme en vivo?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-138">
                Sí. Tienes acceso a la grabación por 48 horas después del
                evento. Pero te recomendamos conectarte en vivo — el ejercicio
                del código funciona mejor en tiempo real.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN — ¿Y DESPUÉS DE LA MASTERCLASS? */}
      <section className="py-16 lg:py-24 bg-[#5D2B85]" data-id="element-139">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-140">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#FFA903] mb-8" data-id="element-141">
            ¿Y después de la masterclass?
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-142">
            Para quienes quieran ir más allá de identificar su patrón y
            trabajarlo en profundidad — habrá una oportunidad especial al final
            de la sesión. Pero todo comienza aquí.
          </p>
        </div>
      </section>

      {/* SECCIÓN 10 — FINAL CTA */}
      <section className="py-16 lg:py-24 bg-[#5D2B85] text-center" data-id="element-143">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
          <h2 className="text-4xl lg:text-6xl font-bold text-[#FFA903] mb-8" data-id="element-145">
            El patrón no desaparece solo.
          </h2>
          <p className="text-xl text-gray-300 mb-12 leading-relaxed text-left sm:text-center" data-id="element-146">
            Puedes seguir intentando, o por fin verlo con claridad. El 14 de
            abril Jaime Nieto te ayudará a identificar el tuyo en vivo. La
            pregunta no es si puedes invertir $2. La pregunta es cuánto te está
            costando seguir en el mismo ciclo.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-147">
            <p className="text-gray-400" data-id="element-148">
              🔒 Riesgo cero · $2 USD · Devolución garantizada en los primeros
              20 minutos
            </p>
            <a href="https://pay.hotmart.com/S105294167I?off=y3iwer8i" target="_blank" rel="noopener noreferrer" onClick={() => {
            const f = window as any;
            if (f.fbq) f.fbq('track', 'InitiateCheckout');
          }} className="w-full sm:w-auto block text-center bg-[#FFD800] hover:bg-[#E6C200] text-black font-bold text-xl sm:text-2xl px-8 py-6 rounded-2xl shadow-[0_4px_14px_rgba(0,0,0,0.25)] border border-[#FFD800]/20 transition-all transform hover:scale-105" data-id="element-149">
              Reserva tu lugar por $2
            </a>
            <p className="text-yellow-500 font-medium mt-4" data-id="element-150">
              ⚠️ El registro cierra el 13 de abril a las 11:59pm. Después de esa
              hora se cierran los accesos a la sesión en vivo.
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-950 py-12 border-t border-gray-800" data-id="element-151">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center space-y-6" data-id="element-152">
          <img src="https://cdn.magicpatterns.com/uploads/6n6s8z46Sz5qmSHydieLVh/LOGO_TRILOGY_350_X_180_(1080_x_1080_px).png" alt="Logo Trilogy" className="h-16 w-auto object-contain mb-4" data-id="element-153" />
          <div className="space-y-2 text-gray-400" data-id="element-154">
            <p data-id="element-155">
              El Código del Límite · Masterclass virtual en vivo con Jaime Nieto
              · 14 de abril · 8pm Colombia · En vivo por Zoom · $2 USD
            </p>
            <p data-id="element-156">WhatsApp: [número] · Email: [email]</p>
          </div>
          <p className="text-gray-600 text-sm pt-8" data-id="element-157">
            © 2025 Trilogy · Todos los derechos reservados
          </p>
        </div>
      </footer>
    </div>;
}